
import styled from "styled-components"

import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useScrollLock } from "../../hooks/useScrollLock";
import { useState } from "react";

import { handleActiveSelect } from "../../features/layout/layoutSlice";
import formatConverter from "../../helper/formatConverter";
import PageTopTitle from "../../components/shared/PageTopTitle";
import InputText from "../../components/shared/input/new/InputText";
import InputSelect from "../../components/shared/input/new/InputSelect";
import useWindowDimensions from "../../hooks/useWindowSize";

const yakitOptions = [
    {
        value: 2.62264704000,
        text:"Dizel"
    },
    {
        value: 2.36689151250,
        text:"Benzin"
    },
    {
        value: 1.67078161250,
        text:"LPG"
    }
]

const Container = styled.div`
    width: 100%;
    height: 100%;

    .content{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .list{
            padding: 30px;
            display: flex;
            flex-direction: column;
            gap: 15px;
            width: 100%;
            .desc-container{
                font-size: var(--font-size-sm);
                line-height: 21px;
            }
            .result-container{
                .title-h4{
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-xl);
                    margin-bottom: 5px;
                }
                p{
                    font-size: var(--font-size-sm);
                    line-height: 21px;
                }
                .res{
                    font-size: var(--font-size-md);
                   color: var(--color-main);
                   font-weight: var(--font-weight-lg);
                }
            }
            .item{
                .label{
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-xl);
                    margin-bottom: 5px;
                }
                .res{
                    font-size: var(--font-size-md);
                   color: var(--color-main);
                   font-weight: var(--font-weight-lg);
                }
            }
        }
    }
    .flex{
        display: flex;
        align-items: center;
    }

  @media (max-width: 880px) {
    .list{
        align-items: center !important;
    }

    .res{
        text-align: center;
    }
  }
`


const SeraGaz = () => {

    const dispatch = useDispatch();
    const { lockScroll, unlockScroll } = useScrollLock();

    const {activeSelect} = useSelector(state => state.layout)
    const {windowDimensions} = useWindowDimensions()

    const [resulted, setResulted] = useState()

    //! inputs
    const [yakitType, setYakitType] = useState({
        value: null,
        text:""
    })
    
    const [km100Ortalama, setKm100Ortalama] = useState(null)
    const [yillikToplamKm, steYillikToplamKm] = useState(null)
    //! results
    const [yillikToplamYakitTuketim, setYillikToplamYakitTuketim] = useState(null)

    const [totalKg, setTotalKg] = useState(null)
    const [totalTon, setTotalTon] = useState(null)
    const [emisyonAgac, setEmisyonAgac] = useState(null)


    useEffect(() => {
        if(yakitType.value && km100Ortalama && yillikToplamKm){
            const km100Number = km100Ortalama.replace(/\./g, '')
            const yillikTopKmNumber = yillikToplamKm.replace(/\./g, '')
            const yillikToplamYakitTuketimi =  parseInt(yillikTopKmNumber) / 100 * parseInt(km100Number) 
            setYillikToplamYakitTuketim(yillikToplamYakitTuketimi)
            const kg = yillikToplamYakitTuketimi * yakitType.value
            setTotalKg(kg)

            setTotalTon(kg / 1000)

            setEmisyonAgac(kg / 411,4)

            setResulted(true)
        }
        else{
            setResulted(false)
            setYillikToplamYakitTuketim(null)
        }

    },[yakitType, km100Ortalama, yillikToplamKm])



    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll();

        return () => {
            unlockScroll();
        };
    }, [lockScroll, unlockScroll]);


    const handlePageClick = () => {
        if(activeSelect){
            dispatch(handleActiveSelect(null))
        }
    }

    const handleOptionClick = (opt) => {

        setYakitType(opt)

        //! bu tamamen select le alakalı tıklandığında açık olan select i kapatmak için
        dispatch(handleActiveSelect(null))

    }

    
  const handleChange = (event, type) => {
    const { value } = event.target;

    if (value === '' || /^[0-9.,]+$/.test(value)) {

        // Kullanıcının girdiği değeri Türkçe formatına dönüştür
        const numericValue = parseFloat(value.replace(/\./g, '').replace(/,/g, '.'));
        const formattedNumericValue = numericValue.toLocaleString('tr-TR');

        if(!isNaN(numericValue)){
            if(type === "km100"){
                setKm100Ortalama(formattedNumericValue || "0")
            }
            else{
                steYillikToplamKm(formattedNumericValue || "0")
            }
        }
        else{
            if(type === "km100"){
                setKm100Ortalama("")
            }
            else{
                steYillikToplamKm("")
            }
        }
    }
  };

    return (
        <Container onClick={handlePageClick}>
            <div className="content">
                <PageTopTitle title={"Sera Gazı Emisyonu Hesaplama"} />

                <div className="list">

                    <div className="item">
                        <InputSelect inputWidth={windowDimensions.width > 570 ?  "500px" : "360px"} initialOptions={yakitOptions} labelText="Yakıt Türü" name={"yakitType"} data={yakitType?.text} setData={handleOptionClick} />
                    </div>

                    <div className="item">
                        <InputText inputWidth={windowDimensions.width > 570 ?  "500px" : "360px"} labelText="100 Km de Ortalama Yakıt Tüketimi (Litre)" name={"km100Ortalama"} data={km100Ortalama} setData={(e)=> handleChange(e, "km100")} />
                    </div>

                    <div className="item">
                        <InputText inputWidth={windowDimensions.width > 570 ?  "500px" : "360px"} labelText="Yapılan Toplam Km" name={"yillikToplamKm"} data={yillikToplamKm} setData={(e)=> handleChange(e, "yilliktoplamKm")} />
                    </div>

                    <div className="item">
                        <div className="label">Toplam Yakıt Tüketimi (Litre):</div>
                        <div className="res">{formatConverter(yillikToplamYakitTuketim, 0)}</div>
                    </div>

                    {
                        resulted ? 

                        <div className="result-container">
                            <h4 className="title-h4">Toplam Sera Gazı Emisyonu:</h4>
                            <p className="res">{formatConverter(totalKg, 1)} Kg</p>
                            <p className="res">{formatConverter(totalTon, 1)} Ton</p>
                            <p className="res">Bu emisyon {formatConverter(emisyonAgac, 0)} adet ağaca eşdeğerdir.</p>
                            <p className="desc">Yetişkin bir ağaç, bir yılda 411,4 kilogram Karbondioksit (CO<sub>2</sub>) gazını fotosentez yoluyla oksijene (0<sub>2</sub>) dönüştürebilmektedir.</p>
                        </div>
                        :
                        <div className="desc-container">
                            <p>Karbon dioksit (CO<sub>2</sub>), Metan (CH<sub>4</sub>), Nitröz Oksit (N<sub>2</sub>O) gibi atmosferde sera gazı etkisi göstererek ısı tutma özelliğine sahip gazlara sera gazı denir.</p>
                            <p>Güneşten dünyamıza gelen ışınlar atmosferden filtrelenerek geçer. Sera gazları yeryüzü etrafında sera etkisi yaparak dünyamızın ısısının artmasına sebep olur. Bu da dünyanın her geçen gün ortalama sıcaklıkların artmasına, iklimlerin değişmesine, buzulların azalmasına, denizlerin yükselmesine sebep olmaktadır.</p>
                            <p>Araçlarımızda fosil yakıtların yanması sonucu ekzozdan bu sera gazları atılmaktadır. Bu da dünyamızı daha ısıtmakta ve iklimlerin değişmesine sebep olmaktadır. Denizler yükselmeye ve dünyamız çölleşmeye doğru gitmektedir.</p>
                            <p>Salınan sera gazlarını azaltmanın yollarından biri de; araçların bakımlarının yapılması, yakıt verimliliği ve daha az fosil yakıt kullanılmasıdır.</p>
                            {/* <p>Yakıt Türü,100 Km de Ortalama Yakıt Tüketimi(Litre) ve Yıllık Yapılan Toplam Km değerlerini girerek </p> */}
                        </div>
                    }

                </div>
            </div>

        </Container>
    );
};


export default SeraGaz